import React from "react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { getRouteLocalizationNamespaces } from "../../../../methods/getRouteLocalizationNamespaces";

import Faq from "components/faq/Faq";
import { FaqCategories } from "@vahak/core/dist/constants/Faq";

interface FaqProps {
    slug: string;
    locale: string;
}

export default function FaqWeb({ slug, locale }: FaqProps) {
    return <Faq slug={slug} locale={locale} />;
}

export async function getStaticProps(context: any) {
    const params = context?.params?.params || null;

    return {
        props: {
            ...(await serverSideTranslations(context.locale, getRouteLocalizationNamespaces("faq"))),
            slug: params || "",
            locale: context.locale || "",
            isMobile: false
        }
    };
}

export async function getStaticPaths() {
    const locales = ["", "hi"];
    const paths = [];
    for (const category of FaqCategories) {
        for (const locale of locales) {
            paths.push({
                params: { params: category.slug },
                locale
            });
        }
    }
    return {
        paths: paths,
        fallback: false
    };
}
